import React from 'react';

import './DashboardCategoryList.scss';
import { link } from '../../helpers/link';
import icons from '../../shared/assets/icons';
import sendEvent from '../../helpers/tracking';
import { isPartner } from '../../helpers/user';
import { getString } from '../../helpers/styles';
import ExpertList from '../ExpertList/ExpertList.jsx';
import { babyMonthList } from '../../helpers/userWeek';
import ArticleList from '../ArticleList/ArticleList.jsx';
import BackButton from '../BackButton/BackButton.jsx';

const {
  News,
  Star,
  Chat,
  File,
  Apple,
  Heart,
  Alarm,
  Cross,
  Question,
  CheckBox,
  Calendar,
  Settings,
  FileShare,
  GooglePlay,
  Appointment,
  ProfileSettings
} = icons;

const colors = [
  '#ADD9EB',
  '#FF7897',
  ' #CB3456',
  '#CAA1B8',
  '#80325f',
  '#1F99CA'
];

export default function DashboardCategoryList(props) {
  const { view, asPath, user, channelContentList = [] } = props;

  const isSidebarView = ['sidebar', 'profileSidebar'].includes(view);

  const providerChannelLink = retrieveProviderChannelLink(user);

  const userWeekLink = buildUserWeekLink(user);

  const provider = user.provider || {};

  const isProfileSectionPage = asPath === '/dashboard/profile';

  const profileSection = {
    smallTiles: true,
    title: 'Mijn Profiel',
    items: [
      {
        title: 'Mijn profiel instellingen',
        link: '/profile-settings',
        icon: Settings,
        onClick: () => sendEvent('Dashboard', 'MyProfileSettings', 'Profile')
      },
      {
        title: 'Mijn opgeslagen artikelen',
        link: '/bookmarks',
        icon: Heart,
        class: 'dashboardCategoryList_transparent_icon',
        onClick: () => sendEvent('Dashboard', 'SavedArticles', 'Profile')
      },
      {
        title: 'Mijn familie voordeel programma',
        icon: Star,
        link: '/saved-products',
        class: 'dashboardCategoryList_transparent_icon',
        onClick: () => sendEvent('Dashboard', 'MyFamilyProgram', 'Profile')
      },
      {
        title: 'Kanalen die ik volg',
        link: '/followed-channels',
        icon: Alarm,
        onClick: () => sendEvent('Dashboard', 'FollowedChannels', 'Profile')
      },
      {
        title: 'Mijn checklists',
        link: '/saved-checklists',
        icon: CheckBox,
        onClick: () => sendEvent('Dashboard', 'Checklists', 'Profile')
      },
      {
        title: 'Veelgestelde vragen (FAQ)',
        link: '/veelgestelde-vragen-faq',
        icon: Question
      }
    ]
  };

  const sections = isProfileSectionPage
    ? [profileSection]
    : [
        {
          title: 'Mijn Zwangerschap',
          items: [
            {
              title: 'Mijn dossier',
              link: '/files',
              icon: File,
              image: '/dashboardCategories/file.png',

              ...(!provider.dossierFeature && {
                class: 'dashboardCategoryList_item_disabled'
              }),

              onClick: (e) => {
                checkFeature(e, 'dossierFeature');

                sendEvent('Dashboard', 'File', 'MyPregnancy');
              }
            },
            {
              title: 'Mijn afspraken',
              link: '/appointments',
              icon: Appointment,
              image: '/dashboardCategories/appointments.png',

              ...(!provider.appointmentsFeature && {
                class: 'dashboardCategoryList_item_disabled'
              }),

              onClick: (e) => {
                checkFeature(e, 'appointmentsFeature');

                sendEvent('Dashboard', 'Appointments', 'MyPregnancy');
              }
            },
            ...(providerChannelLink
              ? [
                  {
                    title: 'Mijn zorgverlener',
                    link: `/${providerChannelLink}`,
                    icon: Cross,
                    image: '/dashboardCategories/obstetricPractice.png',
                    onClick: () =>
                      sendEvent('Dashboard', 'Company', 'MyPregnancy')
                  }
                ]
              : []),
            {
              title: 'Mijn magazine',
              link: '/?tab=news',
              icon: News,
              image: '/dashboardCategories/news.png',
              onClick: () => sendEvent('Dashboard', 'Magazine', 'MyPregnancy')
            },
            ...(userWeekLink
              ? [
                  {
                    title: 'Mijn week',
                    link: userWeekLink,
                    icon: Calendar,
                    image: '/dashboardCategories/week.png',
                    onClick: () => sendEvent('Dashboard', 'Week', 'MyPregnancy')
                  }
                ]
              : [])
          ]
        },
        {
          smallTiles: true,
          title: 'Communicatie met jouw verloskundige',
          items: [
            {
              title: '1-op-1 chat',
              link: '/rooms',
              icon: Chat,

              ...(!provider.chatFeature && {
                class: 'dashboardCategoryList_item_disabled'
              }),

              onClick: (e) => {
                checkFeature(e, 'chatFeature');

                sendEvent('Dashboard', 'Rooms', 'Communication');
              }
            },
            {
              title: 'Gedeelde documenten',
              link: '/shared-folders',
              icon: FileShare,

              ...(!provider.filesFeature && {
                class: 'dashboardCategoryList_item_disabled'
              }),

              onClick: (e) => {
                checkFeature(e, 'filesFeature');

                sendEvent('Dashboard', 'Sharedfolders', 'Communication');
              }
            }
          ]
        }
      ];

  return (
    <section
      id="dashboardCategoryList"
      className={getString([
        {
          value: 'dashboardCategoryList',
          condition: true
        },
        {
          value: 'dashboardCategoryList_sidebar',
          condition: isSidebarView
        }
      ])}
    >
      {isProfileSectionPage && <BackButton path="/dashboard" />}

      {view === 'sidebar'
        ? sidebar('Mijn Zwangerschap', asPath)
        : view === 'profileSidebar'
          ? sidebar('Mijn Profiel', asPath)
          : isPartner(user)
            ? sectionItem(profileSection)
            : sections.map((item) => sectionItem(item))}

      {!isPartner(user) && channelContentList.length && (
        <ArticleList
          {...props}
          unlimitedList={true}
          view="dashboardSection"
          list={channelContentList}
          title="Updates van jouw zorgverlener"
        />
      )}

      {!isProfileSectionPage && (
        <div className="dashboardCategoryList_mobile_app_buttons">
          <a href="https://www.zwangerenportaal.nl/ios-app-download?pk_kwd=ios">
            <span>
              <Apple />
            </span>
            <span>IOS app download</span>
          </a>
          <a href="https://www.zwangerenportaal.nl/android-app-download?pk_kwd=android">
            <span>
              <GooglePlay />
            </span>
            <span>Android app download</span>
          </a>
        </div>
      )}
    </section>
  );

  function checkFeature(e, name) {
    if (!provider.accountName)
      e.preventDefault(),
        showMessagePopup(
          'Je bent nog niet gelinkt aan een zorgverlener.',
          ' Zorgverlener toevoegen',
          '/profile-settings'
        );
    else if (!provider[name]) e.preventDefault(), showMessagePopup();
  }

  function showMessagePopup(
    message = `Helaas, deze functie wordt niet ondersteund
        door jouw zorgverlener.`,
    buttonLabel = 'Doorgaan',
    buttonLink
  ) {
    props.showMessagePopup({
      message,
      buttonLabel,
      buttonLink
    });
  }

  function sectionItem(item, currentPage) {
    const { title, smallTiles, items } = item;

    return (
      <div
        key={title}
        className={getString('dashboardCategoryList_small_tiles', smallTiles)}
      >
        {!isProfileSectionPage && (
          <p className="dashboardCategoryList_title">
            {title}

            {title === 'Mijn Zwangerschap' && (
              <span
                className="dashboardCategoryList_title_icon"
                onClick={() => (location.href = '/dashboard/profile')}
              >
                <ProfileSettings />
              </span>
            )}
          </p>
        )}

        <ul>
          {items.map((item, idx) =>
            listItem({ idx, item, currentPage, items })
          )}
        </ul>
      </div>
    );
  }

  function listItem({ idx, item, currentPage, items }) {
    if (currentPage === item.link) return;

    const backgroundColor =
      items.length <= 3 ? colors[items.length - idx] : colors[idx];

    return (
      <li
        key={item.title}
        {...(item.class && { className: item.class })}
        {...(item.onClick && { onClick: item.onClick })}
        {...(item.image && { style: { backgroundImage: `url(${item.image}` } })}
      >
        {link(
          <div className="dashboardCategoryList_category">
            <div style={{ backgroundColor }}>
              <item.icon />
            </div>

            <div>
              <item.icon />

              <p className="dashboardCategoryList_category_title">
                {item.title}
              </p>
            </div>
          </div>,
          item.link
        )}
      </li>
    );
  }

  function sidebar(sectionTitle, currentPage) {
    const section = [...sections, profileSection].find(
      (section) => section.title === sectionTitle
    );

    return sectionItem(section, currentPage);
  }
}

function retrieveProviderChannelLink({ provider }) {
  if (!provider) return;

  return (
    (provider.primaryChannel &&
      provider.primaryChannel.uri &&
      `channels/${provider.primaryChannel.uri}`) ||
    (provider.aboutContent && provider.aboutContent.uri)
  );
}

function buildUserWeekLink(user) {
  if (['PREPARING', 'OTHER', 'ENDED'].includes(user.status)) return;
  if (user.status === 'PREGNANT') return `/week-${user.phaseNumeric}`;

  if (user.phaseNumeric <= 17) return `/baby-week-${user.phaseNumeric}`;

  const month = Math.ceil(user.phaseNumeric / 4);

  if (month > 12) return;

  return `/${babyMonthList[month - 5]}`;
}
